# 불량보고서팝업
<template>
	<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001434')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<template v-if="isLoaded">
				<div class="sf-col sf-col-4">
					<sf-card class="p-0 h-100 card_bg">
						<popup-search
							:scrId="scrId"
							ref="popSearch"
							:flgOsGrp="this.flgOsGrp"
							:flgPqyapGrp="this.flgPqyapGrp"
							:flgPqyrvGrp="this.flgPqyrvGrp"
							:flgPqyrgGrp="this.flgPqyrgGrp"
							:flgPqycpGrp="this.flgPqycpGrp"
							:flgPqypoGrp="this.flgPqypoGrp"
							:flgHmcrdGrp="this.flgHmcrdGrp"
							:flgPqylpGrp="this.flgPqylpGrp"
							:flgPqyipGrp="this.flgPqyipGrp"
						></popup-search>
					</sf-card>
				</div>
				<div class="sf-col">
					<sf-card class="border-0 bg-transparent h-100">
						<popup-buttons
							:scrId="scrId"
							:isGlims="isGlims"
							@Refresh="refresh"
							@Close="close"
							@deleteFin="() => close('delete')"
							@PprHistoryOpen="popupPprHistoryOpen"
							:flgOsGrp="this.flgOsGrp"
							:flgPqyapGrp="this.flgPqyapGrp"
							:flgPqyrvGrp="this.flgPqyrvGrp"
							:flgPqyrgGrp="this.flgPqyrgGrp"
							:flgPqycpGrp="this.flgPqycpGrp"
							:flgPqypoGrp="this.flgPqypoGrp"
							:flgHmcrdGrp="this.flgHmcrdGrp"
							:flgPqylpGrp="this.flgPqylpGrp"
							:flgPqyipGrp="this.flgPqyipGrp"
						></popup-buttons>
						<template v-if="isGlims">
							<popup-glims-form-info :scrId="scrId" class="mb-2" @BadTypePopupOpen="badTypePopupOpen"></popup-glims-form-info>
							<popup-form-apcn :scrId="scrId" class="mb-2"></popup-form-apcn>
							<popup-form-prbm :scrId="scrId" class="mb-2"></popup-form-prbm>
							<popup-glims-form-cause :scrId="scrId" class="mb-2"></popup-glims-form-cause>
						</template>
						<template v-if="!isGlims">
							<popup-form-info
								:scrId="scrId"
								class="mb-2"
								@BadTypePopupOpen="badTypePopupOpen"
								@CpnyPopupOpen="cpnyPopupOpen"
							></popup-form-info>
							<popup-form-apcn :scrId="scrId" class="mb-2" />
							<popup-form-prbm :scrId="scrId" class="mb-2" />
							<popup-form-cause
								:scrId="scrId"
								class="mb-2"
								:flgOsGrp="this.flgOsGrp"
								:flgPqyapGrp="this.flgPqyapGrp"
								:flgPqyrvGrp="this.flgPqyrvGrp"
								:flgPqyrgGrp="this.flgPqyrgGrp"
								:flgPqycpGrp="this.flgPqycpGrp"
								:flgPqypoGrp="this.flgPqypoGrp"
								:flgHmcrdGrp="this.flgHmcrdGrp"
								:flgPqylpGrp="this.flgPqylpGrp"
								:flgPqyipGrp="this.flgPqyipGrp"
							/>
						</template>
					</sf-card>
				</div>
			</template>
			<!-- 결함유형 팝업 조회 -->
			<bad-type-popup ref="badTypePopup" @SendData="sendData" @Refresh="refresh" @SendBadTypeData="sendBadTypeData" :scrId="scrId" />
			<!-- 협력사 팝업 조회 -->
			<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
			<!-- 개선이력 팝업 조회 -->
			<popup-ppr-history
				ref="popupPprHistory"
				@SendData="sendData"
				@Refresh="refresh"
				@PprHistoryOpen="popupPprHistoryOpen"
				:scrId="scrId"
				:isGlims="isGlims"
			/>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';

import PopupSearch from './PopupContent/PopupSearch.vue';
import PopupButtons from './PopupContent/PopupButtons.vue';
import PopupFormInfo from './PopupContent/PopupFormInfo.vue';
import PopupFormApcn from './PopupContent/PopupFormApcn.vue';
import PopupFormPrbm from './PopupContent/PopupFormPrbm.vue';
import PopupFormCause from './PopupContent/PopupFormCause.vue';

import PopupGlimsFormInfo from './PopupContent/PopupGlimsFormInfo.vue';
import PopupGlimsFormCause from './PopupContent/PopupGlimsFormCause2.vue';

import BadTypePopup from './PopupContent/BadTypePopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
import PopupPprHistory from './PopupContent/PopupPprHistory.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			isLoaded: false,
			isGlims: false,
			isGbn: '',
			flgOsGrp: false, //시스템관리자
			flgPqyapGrp: false, //관리자(승인)
			flgPqyrvGrp: false, //중간관리자(검토)
			flgPqyrgGrp: false, //업무담당자(작성)
			flgPqycpGrp: false, //외부사용자(협력업체)
			flgPqypoGrp: false,
			flgHmcrdGrp: false,
			flgPqylpGrp: false,
			flgPqyipGrp: false
		};
	},
	async created() {
		// this.setStateInit_();
		await this.getCommCodesOnce_(); //공통코드 한번에 부르기
		// await this.getCommCodes_({ key: 'lugyCdList', codeType: 'LUGY' }); //긴급도
		// await this.getCommCodes_({ key: 'pgsStLpCdList', codeType: 'PGS_ST_LP' }); //진행상태;
		// await this.getCommCodes_({ key: 'pgsStKdCdList', codeType: 'PGS_ST_KD' }); //진행상태;
		// await this.getCommCodes_({ key: 'badTypeLgrpCdList', codeType: 'BAD_TYPE_LGRP' }); //유형;
		// await this.getCommCodes_({ key: 'occuPlCdList', codeType: 'OCCU_PL' }); //발생장소;
		// await this.getCommCodes_({ key: 'rptpPrcsCdList', codeType: 'RPTP_PRCS' }); //고품처리;
		// await this.getCommCodes_({ key: 'mdvRplCdList', codeType: 'MDV_RPL' }); //대책회신;
		// await this.getCommCodes_({ key: 'partGCdList', codeType: 'PART_G' }); //소싱구분;
		// await this.getCommCodes_({ key: 'sndStCdList', codeType: 'SND_ST' });
		// await this.getCommCodes_({ key: 'clmTypeCdList', codeType: 'CLM_TYPE' }); //클래임유형

		await this.getGlimsCommCodes_({ key: 'clmPgsStCdList', mode: 'B', spras: 'EN', zecdgrp: 'QCBA' }); //클래임 진행상태
		await this.getGlimsCommCodes_({ key: 'clmRsltCdList', mode: 'B', spras: 'EN', zecdgrp: 'QCBD' }); //판정결과
		await this.getGlimsCommCodes_({ key: 'judgedStateList', mode: 'B', spras: 'EN', zecdgrp: 'QCBI' }); //판정진행상태
		await this.getGlimsCommCodes_({ key: 'tpWayCdList', mode: 'B', spras: 'EN', zecdgrp: 'C020' }); //운송수단

		// await this.getGlimsCommCodes_({ key: 'clmOccuPlCdList', mode: 'B', spras: 'EN', zecdgrp: 'C005' }); //발생장소

		//this.screen = this.screenArray.get(this.scrId);
		this.getOs(); // 시스템 총괄그룹
		this.getPqyap(); //승인자그룹
		this.getPqyrv(); //검토자그룹
		this.getPqyrg(); //작성자그룹
		this.getPqycp(); //외부사용자(협력업체) 그룹
		this.getPqypo();
		this.getHmcrd();
		this.getPqylp();
		this.getPqyip();
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		async open(row, gbn) {
			this.isLoaded = false;
			this.isGlims = false;
			this.isGbn = gbn;
			this.$sf_toggleLoading(true);
			this.show = true;
			this.setPopupInit_();
			let partGCd = '';
			try {
				if (row) {
					if (row.pprNo !== undefined && row.pprNo !== '' && row.pprNo !== null) {
						//ppr번호가 있을때
						// 부품그룹코드가 K (KD)일 경우 Glims정보를 조회해야함
						await this.getPrtRptInfo_(row)
							.catch(error => {
								this.$sf_toast({
									type: 'error',
									message: error.header.message
								});
								Promise.reject(error);
							})
							.finally(() => {
								this.$sf_toggleLoading(false);
							});
						partGCd = this.detailForm.partGCd;
						if (partGCd === 'K') {
							this.isGlims = true;
						} else {
							this.isGlims = false;
						}
					} else {
						//ppr번호가 없을때
						let params = {
							rowData: row,
							gbn: this.isGbn
						};
						//부품코드로 부품그룹코드 조회 및 구분값에 따라서 조회쿼리 변경됨
						await this.getPartMstInfo_(params)
							.catch(error => {
								// console.log('error >>> ', error);
								this.$sf_toast({
									type: 'error',
									message: error.header.message
								});
								Promise.reject(error);
							})
							.finally(() => {
								this.$sf_toggleLoading(false);
							});
						partGCd = this.partMstInfo.partGCd;
						// 부품그룹코드가 K (KD)일 경우 Glims정보를 조회해야함
						if (partGCd === 'K') {
							this.isGlims = true;
							this.onChangeParam({ key: 'clmTypeCd', value: 'A' }); //클래임 유형
							this.onChangeParam({ key: 'tpWayCd', value: 'S' }); //운송수단
							this.onChangeParam({ key: 'lugyCd', value: 'B' }); //긴급도
							this.onChangeParam({ key: 'abrdRprTm', value: '0' }); //해외공장 RPT

							this.onChangeParam({ key: 'lotQty', value: '0' }); //lot수량
							this.onChangeParam({ key: 'sprtQty', value: '0' }); //격리수량
							this.onChangeParam({ key: 'lnStpTm', value: '0' }); //라인정지시간
							const today = this.$moment().format('YYYY-MM-DD'); //오늘날짜
							this.onChangeParam({ key: 'pprsDd', value: today }); //제기일
							this.onChangeParam({ key: 'rptpPrcsCd', value: 'DSU' }); //고품처리
						} else {
							this.isGlims = false;
						}

						this.onChangeParam({ key: 'partGCd', value: partGCd }); //부품그룹코드(소싱구분)
						this.onChangeParam({ key: 'partNo', value: row.partNo }); //품번
						this.onChangeParam({ key: 'ckuNo', value: row.ckuNo }); //검사번호

						// this.onChangeParam({ key: 'cofCd', value: row.cofCd }); //협력사
						// this.onChangeParam({ key: 'badQty', value: row.badQty }); //불량수량
						// this.onChangeParam({ key: 'lugyCd', value: row.lugyCd }); //긴급도
						// this.onChangeParam({ key: 'occuDd', value: row.occuDd }); //품번
					}
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.$sf_toggleLoading(false);
				this.isLoaded = true;
				//this.isGlims = false;
			}
		},
		close(param) {
			this.show = false;
			this.isLoaded = false;
			this.isGlims = false;
			if (param) {
				this.$emit('Refresh');
			}
			//this.setPopupInit_();
		},
		onPartPopup() {
			this.$sf_toggleLoading(true);
			this.$refs.popSearch.onPartPopup();
		},
		sendData(users, userGbn) {
			// if (userGbn === 'dsprNm' && users.length > 1) {
			// 	const errMsg = this.getMessage_('QWCC001479'); //발신인은 한명만 등록 가능합니다.
			// 	this.$sf_toast({ type: 'error', message: errMsg, option: { duration: 3000 } });
			// 	return;
			// }
			// // const userList = param
			// let { rcptNm, rcptAdr, rfpNm, rfpAdr, dsprNm, dsprAdr } = this.detailForm;
			// let addRcptAddr = '';
			// let addRcptNm = '';
			// let addRfpAdr = '';
			// let addRfpNm = '';
			// let str = '';
			// for (let i = 0; i < users.length; i++) {
			// 	let email = users[i].email;
			// 	let nm = users[i].userName;
			// 	if (email !== '' && email !== undefined && email !== null) {
			// 		if (userGbn === 'rcptNm') {
			// 			//수신자 일경우
			// 			if (i === users.length - 1) {
			// 				addRcptAddr = addRcptAddr + email;
			// 				addRcptNm = addRcptNm + nm;
			// 			} else {
			// 				addRcptAddr = addRcptAddr + email + ';';
			// 				addRcptNm = addRcptNm + nm + ';';
			// 			}
			// 		} else if (userGbn === 'rfpNm') {
			// 			//참조자 일경우
			// 			if (i === users.length - 1) {
			// 				addRfpAdr = addRfpAdr + email;
			// 				addRfpNm = addRfpNm + nm;
			// 			} else {
			// 				addRfpAdr = addRfpAdr + email + ';';
			// 				addRfpNm = addRfpNm + nm + ';';
			// 			}
			// 		} else if (userGbn === 'dsprNm') {
			// 			//발신자 일경우
			// 			dsprAdr = email;
			// 			dsprNm = nm;
			// 		}
			// 	}
			// }
			// if (userGbn === 'rcptNm') {
			// 	str = rcptAdr.charAt(rcptAdr.length - 1);
			// 	if (str !== '' && str !== ';') {
			// 		addRcptAddr = rcptAdr + ';' + addRcptAddr;
			// 		addRcptNm = rcptNm + ';' + addRcptNm;
			// 	}
			// 	this.onChangeParam({ key: 'rcptAdr', value: addRcptAddr });
			// 	this.onChangeParam({ key: 'rcptNm', value: addRcptNm });
			// } else if (userGbn === 'rfpNm') {
			// 	str = rfpAdr.charAt(rfpAdr.length - 1);
			// 	if (str !== '' && str !== ';') {
			// 		addRfpAdr = rfpAdr + ';' + addRfpAdr;
			// 		addRfpNm = rfpNm + ';' + addRfpNm;
			// 	}
			// 	this.onChangeParam({ key: 'rfpAdr', value: addRfpAdr });
			// 	this.onChangeParam({ key: 'rfpNm', value: addRfpNm });
			// } else if (userGbn === 'dsprNm') {
			// 	this.onChangeParam({ key: 'dsprAdr', value: dsprAdr });
			// 	this.onChangeParam({ key: 'dsprNm', value: dsprNm });
			// }
		},
		refresh() {
			this.$emit('Refresh');
		},
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		badTypePopupOpen() {
			this.$refs.badTypePopup.open();
		},
		popupPprHistoryOpen() {
			this.$refs.popupPprHistory.open();
		},
		sendBadTypeData(selCodes) {
			// console.log('selCodes >>>', selCodes);
			this.onChangeParam_({ key: 'badTypeLgrpCd', value: selCodes.badTypeLgrpCd });
			this.onChangeParam_({ key: 'badTypeLgrpNm', value: selCodes.badTypeLgrpNm });
			this.onChangeParam_({ key: 'badTypeMgrpCd', value: selCodes.badTypeMgrpCd });
			this.onChangeParam_({ key: 'badTypeMgrpNm', value: selCodes.badTypeMgrpNm });
			this.onChangeParam_({ key: 'badTypeSgrpCd', value: selCodes.badTypeSgrpCd });
			this.onChangeParam_({ key: 'badTypeSgrpNm', value: selCodes.badTypeSgrpNm });

			this.$refs.badTypePopup.close();
		},
		cpnyPopupOpen(params) {
			this.$refs.compPopup.open(params);
		},
		qpyCpnyData(params) {
			this.onChangeParam_({ key: 'cofCd', value: params.cpnyCd });
			this.onChangeParam_({ key: 'cofNm', value: params.cpnyNm });
		},
		async getOs() {
			this.flgOsGrp = await this.inclUsrGrp_('OS'); //시스템 관리자
		},
		async getPqyap() {
			this.flgPqyapGrp = await this.inclUsrGrp_('PQYAP'); //생산품질 관리자(승인)
		},
		async getPqypo() {
			this.flgPqypoGrp = await this.inclUsrGrp_('PQYPO'); //생산품질 관리자(승인)
		},
		async getPqyrv() {
			this.flgPqyrvGrp = await this.inclUsrGrp_('PQYRV'); //생산품질 중간관리자(검토)
		},
		async getPqyrg() {
			this.flgPqyrgGrp = await this.inclUsrGrp_('PQYRG'); //생산품질 일반사용자(작성)
		},
		async getPqycp() {
			this.flgPqycpGrp = await this.inclUsrGrp_('PQYCP'); //생산품질 외부사용자(협력업체)
		},
		async getHmcrd() {
			this.flgHmcrdGrp = await this.inclUsrGrp_('HMCRD'); //생산품질 외부사용자(협력업체)
		},
		async getPqylp() {
			this.flgPqylpGrp = await this.inclUsrGrp_('PQYLP'); //생산품질 외부사용자(협력업체)
		},
		async getPqyip() {
			this.flgPqyipGrp = await this.inclUsrGrp_('PQYIP'); //생산품질 외부사용자(협력업체)
		}
	},
	components: {
		PopupSearch,
		PopupButtons,
		PopupFormInfo,
		PopupFormApcn,
		PopupFormPrbm,
		PopupFormCause,
		BadTypePopup,
		//Glims 영역
		PopupGlimsFormInfo,
		PopupGlimsFormCause,
		PopupPprHistory,
		//공통 영역
		CompPopup
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed
	}
};
</script>

<style></style>
